"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressFieldText = exports.phoneFieldText = void 0;
const intl_1 = require("@formatjs/intl");
exports.phoneFieldText = (0, intl_1.defineMessages)({
    phone: {
        defaultMessage: "Phone",
        id: "O95R3Z",
    },
    field_description: {
        defaultMessage: "Add one or more formatted phone numbers.",
        id: "K/pzT0",
    },
    enter_phone_here: {
        defaultMessage: "Enter phone here...",
        id: "zBhnab",
    },
    telephone: {
        defaultMessage: "telephone",
        id: "7ZiMiJ",
    },
    cell: {
        defaultMessage: "cell",
        id: "a39+Ww",
    },
    mobile_lower: {
        defaultMessage: "mobile",
        id: "7c3n8r",
    },
    office: {
        defaultMessage: "Office",
        id: "+4MjlG",
    },
    mobile: {
        defaultMessage: "Mobile",
        id: "GWtmtu",
    },
    home: {
        defaultMessage: "Home",
        id: "ejEGdx",
    },
    fax: {
        defaultMessage: "Fax",
        id: "etKfZA",
    },
    other: {
        defaultMessage: "Other",
        id: "/VnDMl",
    },
});
exports.addressFieldText = (0, intl_1.defineMessages)({
    default_address: {
        defaultMessage: "100 Main Street, Suite 300, Los Angeles, California, 90017, United States",
        id: "LyrIaU",
    },
    address: {
        defaultMessage: "Address",
        id: "e6Ph5+",
    },
    type_an_address: {
        defaultMessage: "Type an address...",
        id: "3SFMqt",
    },
    location: {
        defaultMessage: "location",
        id: "PiqxYx",
    },
    street: {
        defaultMessage: "street",
        id: "XAbyxV",
    },
    city: {
        defaultMessage: "city",
        id: "Wfh9EC",
    },
    country: {
        defaultMessage: "country",
        id: "OUDdOB",
    },
    map: {
        defaultMessage: "map",
        id: "Hjyu6/",
    },
});
